/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useReducer } from 'react';
import darkReducer from './darkReducer';

const getInitialDarkMode = () => {
    const savedMode = localStorage.getItem('darkMode');

    if (savedMode === null) {
        return false;
    }

    return JSON.parse(savedMode);
};

const INITIAL_STATE = {
    darkMode: getInitialDarkMode(),
};

export const ColorContext = React.createContext(INITIAL_STATE);

export function ColorContextProvider({ children }) {
    const [state, dispatch] = useReducer(darkReducer, INITIAL_STATE);

    return (
        <ColorContext.Provider
            value={{
                darkMode: state.darkMode,
                dispatch,
            }}
        >
            {children}
        </ColorContext.Provider>
    );
}
